// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__ga8Es","noMargin":"style_noMargin__2tcsc","center":"style_center__0aEnl"};